import {
  required,
  minLength,
} from 'vuelidate/lib/validators';
import FundEditMemberModal from '@/app/modules/fund/components/fund-edit-member-modal/fund-edit-member-modal.vue';
import { getCurrentAge } from '@/app/utils/utils';

export default {
  name: 'fund-person',
  components: {
    FundEditMemberModal,
  },
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showEditMemberModal: false,
    };
  },
  computed: {
    fullName() {
      return `${this.person.firstName} ${this.person.lastName}`;
    },
    age() {
      const age = getCurrentAge(this.person.dateOfBirth);
      return `${age} years old`;
    },
  },
  methods: {
    handleEdit() {
      this.showEditMemberModal = true;
    },
  },
  validations: {
    person: {
      title: {
        required,
      },
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      dateOfBirth: {
        required,
      },
      sex: {
        required,
      },
    },
  },
};
